import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  CircularProgress,
  Alert,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import BarChart from "components/chartNivo/BarChart";


const FeatureAnalysis = ({ computeFeatureImportance }) => {
  const [importances, setImportances] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleCompute = () => {
    setLoading(true);
    setTimeout(() => {
      const result = computeFeatureImportance();
      setImportances(result);
      setLoading(false);
    }, 50);
  };

  const chartData = importances
    ? importances.map((item) => ({
        feature: item.feature,
        y: parseFloat(item.importance.toFixed(6)),
      }))
    : [];

  return (
    <Box height="100%" display="flex" flexDirection="column" gap={1}>
      <Box textAlign="center" flexShrink={0}>
        <Typography variant="body2" color="text.secondary" mb={2}>
          Permutation Importance - measures how much each feature affects prediction accuracy.
          Higher value means the feature has more influence on the delay estimate.
        </Typography>
        <Button
          variant="outlined"
          startIcon={loading ? <CircularProgress size={16} /> : <RefreshIcon />}
          onClick={handleCompute}
          disabled={loading}
        >
          {loading ? "Computing..." : "Compute Feature Importance"}
        </Button>
      </Box>

      {importances && chartData.length > 0 && (
        <Box flex={1} minHeight={0}>
          <BarChart
            data={chartData}
            bottomLegend="Feature"
            leftLegend="Importance (MSE increase)"
            isHorizontalBottomLegend
            bottomOffSet={-100}
            bottomLegendOffSet={-40}
            digit={5}
          />
        </Box>
      )}

      {importances && chartData.every((d) => d.y === 0) && (
        <Alert severity="info" sx={{ textAlign: "center" }}>
          All features show zero importance. Try training with more data or more epochs
          for the model to learn meaningful relationships.
        </Alert>
      )}
    </Box>
  );
};

export default FeatureAnalysis;
